export const features = [
  "kind",
  "pad_type",
  "camper_capacity",
  "has_linens",
  "max_rig_length",
  "extra_car_space",
  "premium_view",
  "electric",
  "electric_15",
  "electric_20",
  "electric_30",
  "electric_50",
  "water",
  "sewage",
  "has_wifi",
  "pets",
  "dog_park",
  "pool",
  "dump_station",
  "public_bathrooms",
  "showers",
  "has_laundry",
  "public_kitchen",
  "picnic_table",
  "cable_tv",
  "fire_pit",
  "general_store",
  "has_heating",
  "has_microwave",
  "has_oven",
  "has_refrigerator",
  "has_stove",
  "has_air_conditioning",
  "has_private_bathroom",
  "number_of_king_beds",
  "number_of_futon_beds",
  "number_of_queen_beds",
  "number_of_full_beds",
  "number_of_twin_beds",
  "number_of_single_beds",
  "number_of_bunk_beds",
  "has_community_fire_pit",
  "has_grill_barbecue",
  "has_restaurant",
  "has_tv",
  "has_playground",
  "has_propane_fill_up",
  "has_volleyball_court",
  "has_basketball_court",
  "disc_golf_course",
  "has_golf_course",
  "has_mini_golf_course",
  "has_hotplate",
  "has_towels",
]

export const booleanFeatures = [
  "sewage",
  "fire_pit",
  "has_grill_barbecue",
  "pets",
  "has_wifi",
  "extra_car_space",
  "premium_view",
  "cable_tv",
]

export const lodgingFeatures = [
  "has_towels",
  "has_private_bathroom",
  "has_heating",
  "has_air_conditioning",
  "has_microwave",
  "has_oven",
  "has_stove",
  "has_hotplate",
  "has_refrigerator",
  "has_tv",
]

export const bedFeatures = [
  "number_of_single_beds",
  "number_of_twin_beds",
  "number_of_bunk_beds",
  "number_of_futon_beds",
  "number_of_full_beds",
  "number_of_queen_beds",
  "number_of_king_beds",
]

//hold off on these for now
export const campFeatures = [
  "dog_park",
  "pool",
  "dump_station",
  "public_bathrooms",
  "showers",
  "has_laundry",
  "public_kitchen",
  "picnic_table",
  "general_store",
  "has_playground",
  "has_propane_fill_up",
  "has_volleyball_court",
  "has_basketball_court",
  "disc_golf_course",
  "has_golf_course",
  "has_mini_golf_course",
  "has_restaurant",
  "has_community_fire_pit",
]
